import { publicApps } from '../data/apps';
import { AppCard } from './AppCard';

export function AppGrid() {
  return (
    <div className="app-grid">
      {publicApps.map((app) => (
        <AppCard app={app} key={app.slug} />
      ))}
    </div>
  );
}
